<!-- 核心资源新增编辑 -->
<template>
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="50%">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="标题" prop="title">
                <el-input v-model="form.title" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="简介" prop="info">
                <el-input v-model="form.info" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="图片" prop="photoUrl">
                <UploadImage
                    :width="200"
                    :height="150"
                    :maxSize="20"
                    :value="form.photoUrl"
                    ref="uploadImage"
                    @on-change="handleImageChange"
                    @on-remove="handleImageRemove"
                />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input
                    v-model="form.sort"
                    type="number"
                    min="0"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitForm" :loading="loading" :disabled="loading">保存</el-button>
        </span>
    </el-dialog>
</template>

<script>
import UploadImage from "@/components/UploadImage.vue";
import {
    areaCoreResourceSave, //核心资源 - 新增
    areaCoreResourceUpdate, //核心资源 - 编辑
} from "@/api/admin";

export default {
    name: "LocalPlatform",
    props: ["areaType"],
    components: {
        UploadImage,
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            dialogTitle: "新增",
            form: {
                title: "",
                info: "",
                photoUrl: "",
                sort: undefined,
            },
            rules: {
                title: [
                    { required: true, message: "请输入标题", trigger: "blur" },
                ],
                info: [
                    { required: true, message: "请输入简介", trigger: "blur" },
                ],
                photoUrl: [
                    {
                        required: true,
                        message: "请上传图片",
                        trigger: "change",
                    },
                ],
                sort: [
                    { required: true, message: "请输入排序", trigger: "blur" },
                ],
            },
        };
    },
    methods: {
        submitForm() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    if (this.loading) return; // 防止重复提交
                    try {
                        this.loading = true;
                        const params = {
                            ...this.form,
                            areaType: this.areaType
                        };
                        if (this.form.id) {
                            await areaCoreResourceUpdate(params);
                        } else {
                            await areaCoreResourceSave(params);
                        }
                        this.$message.success("保存成功");
                        this.$emit("refresh");
                        this.dialogVisible = false;
                    } catch (error) {
                        this.$message.error(error.message || "保存失败");
                    } finally {
                        setTimeout(() => {
                            this.loading = false;
                        }, 1000);
                    }
                } else {
                    this.$message.error("请填写完整信息");
                    return false;
                }
            });
        },
        handleImageChange(file) {
            this.form.photoUrl = file;
        },
        handleImageRemove() {
            this.form.photoUrl = "";
        },
        open(row) {
            this.dialogVisible = true;
            if (row) {
                // 编辑
                this.dialogTitle = "编辑核心资源";
                this.form = { ...row };
            } else {
                // 新增
                this.dialogTitle = "新增核心资源";
                this.form = {
                    title: "",
                    photoUrl: "",
                    sort: undefined,
                };
            }
        },
    },
};
</script>

<style scoped>
.dialog-footer {
    text-align: right;
}
</style>
